import React from "react";
import Chat from "../components/Chat";

const ChatPage = () => {
  return <Chat />;
};

export default ChatPage;
